import { isNumber } from 'lodash'
import { onBeforeUnmount, onMounted, watchEffect, ref } from 'vue'


function addUnit(value, defaultUnit = 'px') {
  if (!value) return ''
  if (typeof value === 'string') {
    return value
  } if (isNumber(value)) {
    return `${value}${defaultUnit}`
  }
}

export const HAS_TOUCH = process.env.SERVER ? true : 'ontouchstart' in window
export const START_EVENT = HAS_TOUCH ? 'touchstart' : 'mousedown'
export const MOVE_EVENT = HAS_TOUCH ? 'touchmove' : 'mousemove'
export const END_EVENT = HAS_TOUCH ? 'touchend' : 'mouseup'
export const getClient = e => {
  const clientX = HAS_TOUCH ? e.changedTouches[0].clientX : e.clientX
  const clientY = HAS_TOUCH ? e.changedTouches[0].clientY : e.clientY
  return {
    x: clientX,
    y: clientY
  }
}

export const useDraggable = (
  targetRef,
  dragRef,
  draggable,
  autoSticky
) => {
  const hasDrag = ref(false);
  if (!targetRef || !dragRef) return { hasDrag }
  let transform = {
    offsetX: 0,
    offsetY: 0,
  }
  const addTransition = () => {
    targetRef.value.style.transition = 'transform .3s';
  }
  const removeTransition = () => {
    targetRef.value.style.transition = '';
  }

  const onMousedown = (e) => {
    document.body.style.overflow = 'hidden';
    e.stopPropagation();
    removeTransition();
    const { x: downX, y: downY } = getClient(e);
    const { offsetX, offsetY } = transform

    const targetRect = targetRef.value.getBoundingClientRect()
    const targetLeft = targetRect.left
    const targetTop = targetRect.top
    const targetWidth = targetRect.width
    const targetHeight = targetRect.height

    const { clientWidth } = document.documentElement
    const { clientHeight } = document.documentElement

    const minLeft = -targetLeft + offsetX
    const minTop = -targetTop + offsetY
    const maxLeft = clientWidth - targetLeft - targetWidth + offsetX
    const maxTop = clientHeight - targetTop - targetHeight + offsetY

    const onMousemove = (ee) => {
      ee.stopPropagation();
      hasDrag.value = true;
      const { x, y } = getClient(ee);
      const moveX = Math.min(
        Math.max(offsetX + x - downX, minLeft),
        maxLeft
      )
      const moveY = Math.min(
        Math.max(offsetY + y - downY, minTop),
        maxTop
      )

      transform = {
        offsetX: moveX,
        offsetY: moveY,
      }
      targetRef.value.style.transform = `translate(${addUnit(
        moveX
      )}, ${addUnit(moveY)})`
    }

    const onMouseup = (upE) => {
      document.body.style.overflow = 'auto';
      setTimeout(() => { hasDrag.value = false; }, 300)
      upE.stopPropagation();
      addTransition();
      document.removeEventListener(MOVE_EVENT, onMousemove)
      document.removeEventListener(END_EVENT, onMouseup)

      const { x } = getClient(upE);

      if (autoSticky?.value) {
        const dir = x < (clientWidth / 2) ? 'left' : 'right';
        const mx = dir === 'left' ? minLeft + 5 : maxLeft - 5;
        transform.offsetX = mx;
        targetRef.value.style.transform = `translate(${addUnit(
          mx
        )}, ${addUnit(transform.offsetY)})`
      }
    }

    document.addEventListener(MOVE_EVENT, onMousemove, false)
    document.addEventListener(END_EVENT, onMouseup, false)
  }

  const onDraggable = () => {
    if (dragRef.value && targetRef.value) {
      dragRef.value.addEventListener(START_EVENT, onMousedown, false)
    }
  }

  const offDraggable = () => {
    if (dragRef.value && targetRef.value) {
      dragRef.value.removeEventListener(START_EVENT, onMousedown)
    }
  }

  onMounted(() => {
    watchEffect(() => {
      if (draggable.value) {
        onDraggable()
      } else {
        offDraggable()
      }
    })
  })

  onBeforeUnmount(() => {
    offDraggable()
  })

  return { hasDrag }
}
